<footer [ngClass]="footerCss">
  <div class="text-center">
    {{ footerData }}
  </div>
</footer>
